import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IOperateurService } from '../../../../../core/services/operateur.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IStateParamsService } from 'angular-ui-router';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
import { IFilterExDate } from '../../../../../core/filters/ex-date.filter';
import { IFormulaireItemDividerClass } from '../../../../../core/services/formulaire/formulaire-item-divider.service';

interface IPageMc0120 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
}
/* @ngInject */
export default function Mc0120Controller(Operateur: IOperateurService,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireItemDivider: IFormulaireItemDividerClass,
    $stateParams: IStateParamsService,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    Pagination: IPaginationClass,
    exDateFilter: IFilterExDate
) {
    const vm: IPageMc0120 = this;
   
    vm.valeursEcran = ecranDetails.valeurs;  
    vm.multiOccurrenceOptions = {
        criteresSuggeres: new Formulaire([
            new FormulaireItem('refcleint',{
                required: false
            }),
            new FormulaireItem('refnomabr',{
                required: false
            }),
            new FormulaireItem('refnom',{
                required: false
            }),
            new FormulaireItem('t_fouflgstu',{
                default:vm.valeursEcran.fouflgstu
            }),
            new FormulaireItem('rxpdatenv',{
                default: exDateFilter(new Date())
            }), 
            new FormulaireItemDivider('LBL_FORMAT'),
            new FormulaireItem('t_codpos'),
            new FormulaireItem('t_ligne_blanche'),
            new FormulaireItem('rxptypadr',{
                default:vm.valeursEcran.rxptypadr
            })
        ]),
        fonctions: {
            rechercheCollapsable: false,
            criteresSuggeresVisibles: true,
            effaceCriteres:true,
            reinitialiserOuvrirCriteres:true
        },
        pagination: new Pagination({
            nombreElementPage: 100,
            nbElementsPossibles: [100, 250, 500]
        }),
        colonnesFixesGauche: [
            { nom: 'refcod', largeur: 150 },
            { nom: 'refnomabr', largeur: 210 },
            { nom: 'refnom', largeur: 210 },
            { nom: 'fouflgstu', largeur: 210 }
        ],
        colonnesVisibles: [
            { nom: 'radadrl01', largeur: 210 },
            { nom: 'radadrl02', largeur: 210 },
            { nom: 'radadrl03', largeur: 210 },
            { nom: 'radadrl04', largeur: 210 },
            { nom: 'radadrl05', largeur: 210 },
            { nom: 'radnumtel', largeur: 210 },
            { nom: 'radnumfax', largeur: 210 }
        ]
    };
}

